<template>
    <div>
        <div class="row mt_dec--30 row--24">
            <div :class="column"
                 v-for="(gallery, index) in galleryData"
                 :key="index">
                <div class="rn-gallery icon-center" data-aos="fade-up" style="border: 1px solid #efefef;text-align: center;">
                    <div class="thumbnail">
                        <img class="radius-small mt--10"
                            v-if="gallery.thumb"
                            :src="gallery.thumb"
                            alt="Video Thumbnail"
                            style="width:80%;"/>
                            <p style="font-size: 14px;">{{gallery.name}}</p>
                    </div>
                    <div class="video-icon">
                        <Button variant-button-class="rounded-player sm-size"
                                :is-link="false"
                                @btnClick="imageIndex = index">
                            <span><Icon :name="gallery.type === 'video' ? 'play' : 'zoom-in'" size="30"/></span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>

        <CoolLightBox
            :items="galleryData"
            :index="imageIndex"
            @close="imageIndex = null">
        </CoolLightBox>
    </div>
</template>

<script>
    import Icon from '../../icon/Icon'
    import Button from '../button/Button'

    export default {
        name: 'Gallery',
        components: {Button, Icon},
        props: {
            galleryData: {},
            column: {
                type: String,
                default: 'col-lg-2 col-md-6 col-24 mt--30'
            }
        },
        data() {
            return {
                imageIndex: null
            }
        }
    }
</script>